import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status-indicator raiseHandIndicator"
}
const _hoisted_2 = {
  key: 0,
  class: "bottom-bar"
}
const _hoisted_3 = {
  key: 3,
  class: "status-indicator iceFailedIndicator"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconHandBackLeft = _resolveComponent("IconHandBackLeft")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_IconMicrophone = _resolveComponent("IconMicrophone")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconVideo = _resolveComponent("IconVideo")
  const _component_IconVideoOffOutline = _resolveComponent("IconVideoOffOutline")
  const _component_IconMonitor = _resolveComponent("IconMonitor")
  const _component_IconAlertCircleOutline = _resolveComponent("IconAlertCircleOutline")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", { 'wrapper--big': $props.isBig }]),
    onMouseover: _cache[0] || (_cache[0] = _withModifiers($event => ($data.mouseover = true), ["stop"])),
    onMouseleave: _cache[1] || (_cache[1] = _withModifiers($event => ($data.mouseover = false), ["stop"]))
  }, [
    _createVNode(_component_TransitionWrapper, { name: "fade" }, {
      default: _withCtx(() => [
        ($options.showRaiseHandIndicator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_IconHandBackLeft, {
                size: 18,
                "fill-color": "#ffffff"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!$props.isSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TransitionWrapper, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["participant-name", {
						'participant-name--active': $options.isCurrentlyActive,
						'participant-name--has-shadow': $props.hasShadow,
					}])
              }, _toDisplayString($props.participantName), 3), [
                [_vShow, $options.showParticipantName]
              ])
            ]),
            _: 1
          }),
          (!$props.isScreen)
            ? _withDirectives((_openBlock(), _createBlock(_component_TransitionWrapper, {
                key: 0,
                class: "media-indicators",
                name: "fade",
                group: ""
              }, {
                default: _withCtx(() => [
                  ($options.showAudioIndicator)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 0,
                        title: $options.audioButtonTitle,
                        "aria-label": $options.audioButtonTitle,
                        class: "audioIndicator",
                        variant: "tertiary-no-background",
                        disabled: $options.isAudioButtonDisabled,
                        onClick: _withModifiers($options.forceMute, ["stop"])
                      }, {
                        icon: _withCtx(() => [
                          ($props.model.attributes.audioAvailable)
                            ? (_openBlock(), _createBlock(_component_IconMicrophone, {
                                key: 0,
                                size: 20
                              }))
                            : (_openBlock(), _createBlock(_component_NcIconSvgWrapper, {
                                key: 1,
                                svg: $setup.IconMicrophoneOffOutline,
                                size: 20
                              }, null, 8, ["svg"]))
                        ]),
                        _: 1
                      }, 8, ["title", "aria-label", "disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  ($options.showVideoIndicator)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 1,
                        title: $options.videoButtonTitle,
                        "aria-label": $options.videoButtonTitle,
                        class: "videoIndicator",
                        variant: "tertiary-no-background",
                        onClick: _withModifiers($options.toggleVideo, ["stop"])
                      }, {
                        icon: _withCtx(() => [
                          ($options.isRemoteVideoEnabled)
                            ? (_openBlock(), _createBlock(_component_IconVideo, {
                                key: 0,
                                size: 20
                              }))
                            : (_openBlock(), _createBlock(_component_IconVideoOffOutline, {
                                key: 1,
                                size: 20
                              }))
                        ]),
                        _: 1
                      }, 8, ["title", "aria-label", "onClick"]))
                    : _createCommentVNode("", true),
                  ($options.showScreenSharingIndicator)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 2,
                        title: $options.t('spreed', 'Show screen'),
                        "aria-label": $options.t('spreed', 'Show screen'),
                        class: _normalizeClass(["screenSharingIndicator", { 'screen-visible': $props.sharedData.screenVisible }]),
                        variant: "tertiary-no-background",
                        onClick: _withModifiers($options.switchToScreen, ["stop"])
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconMonitor, { size: 20 })
                        ]),
                        _: 1
                      }, 8, ["title", "aria-label", "class", "onClick"]))
                    : _createCommentVNode("", true),
                  ($options.connectionStateFailedNoRestart)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_IconAlertCircleOutline, { size: 20 })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512)), [
                [_vShow, $props.showVideoOverlay]
              ])
            : _createCommentVNode("", true),
          ($options.showStopFollowingButton)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 1,
                class: "following-button",
                variant: "tertiary",
                onClick: $options.handleStopFollowing
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.t('spreed', 'Stop following')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}